import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import faCheckSquare from '@fortawesome/fontawesome-pro-light/faCheckSquare';
import faSquare from '@fortawesome/fontawesome-pro-light/faSquare';
import faExternalLink from '@fortawesome/fontawesome-pro-light/faExternalLink';
import './Term.css';

function getTermHref(sophasStatus, sophasId, nonSophasId) {
  let programId = '';
  let normalizedStatus = '';

  if (sophasStatus === 'sophas' || sophasStatus === 'sophas_express') {
    programId = sophasId;
    normalizedStatus = 'sophas';
  } else if (sophasStatus === 'non_sophas') {
    programId = nonSophasId;
    normalizedStatus = 'non_sophas';
  }

  if (!programId) return null;
  return `/?program_id=${programId}&sophas_status=${normalizedStatus}`;
}

const Term = ({
  startTerm,
  startYear,
  concentration,
  delivery,
  applicationType,
  deadline,
  sophasStatus,
  sophasId,
  nonSophasId,
  onTermClick,
}) => {
  const href = getTermHref(sophasStatus, sophasId, nonSophasId);

  return (
    <tr className="Term--row">
      <td>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onTermClick}
        >
          {startTerm} {startYear} <FontAwesomeIcon icon={faExternalLink} />
        </a>
      </td>
      <td>{concentration}</td>
      <td>{delivery}</td>
      <td>{applicationType}</td>
      <td>{deadline}</td>
      <td>
        {sophasStatus !== 'non_sophas' ? (
          <FontAwesomeIcon icon={faCheckSquare} />
        ) : (
          <FontAwesomeIcon icon={faSquare} />
        )}
      </td>
    </tr>
  );
};

export default Term;
